import { Box } from '@chakra-ui/react';

export function ShinyHoverEffect() {
  return (
    <Box
      bgGradient='linear(to-b, transparent, white, transparent)'
      bottom={0}
      height='120%'
      mixBlendMode='soft-light'
      opacity={0.3}
      pointerEvents='none'
      position='absolute'
      right={0}
      transform={`translateX(50%) translateY(100%) rotate(-20deg)`}
      transition='transform 0.3s ease-in-out'
      width='200%'
      zIndex={1}
      _groupHover={{
        transform: `translateX(10%) translateY(-10%) rotate(-20deg)`,
      }}
    />
  );
}
